import { Box, Grid } from '@mui/material'
import {
  Button,
  Card,
  DateRangePickerC,
  Form,
  // ResetButton,
  ResetFilters,
  SelectSeller
} from '../../../../components'
import { formatDate } from '../../../../utils'
import { existsFilters } from '../../../../utils/helpers'
import Yup from '../../../../utils/helpers/Yup'
import { useComissionsReportContext } from '../context/comissionsReport.context'
import { commissionsReport } from '../../../../services/api/Reports'
import { SelectCustomer } from 'modules/orders/components'

type FormValues = {
  customerId: {
    companyId: string
  } | null
  date: string[] | null[]
}

const comissionsSchema = Yup.object({
  customerId: Yup.object({
    companyId: Yup.string().required()
  }).nullable(),
  date: Yup.mixed().test({
    name: 'dateRange',
    message: 'Deve conter data de início e fim!',
    test: (value) => {
      const isEmpty = value.every((e: any) => e === null)
      if (isEmpty) return isEmpty
      return value.every((e: any) => e !== null)
    }
  })
})

const defaultValues = {
  customerId: null,
  date: [null, null]
}

const ComissionsReportProvided = () => {
  const { filters, setFilters } = useComissionsReportContext()

  return (
    <div>
      <>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                visibility: { xs: 'hidden', sm: 'hidden', md: 'visible' },
                display: 'flex',
                flexDirection: 'row',
                gap: '10px',
                marginBottom: '20px'
              }}
            >
              <Box
                sx={{
                  visibility: { xs: 'visible', sm: 'visible', md: 'visible' },
                  width: '100%'
                }}
              >
                <DateRangePickerC
                  name="date"
                  inputFormat="dd/MM/yyyy"
                  startText="Data Inicial"
                  endText="Data Final"
                  sx={{ width: '100%' }}
                />
                <Box sx={{ marginTop: '1.25rem' }}>
                  <SelectCustomer />
                </Box>
                <Box sx={{ marginTop: '1.25rem' }}>
                  <SelectSeller />
                </Box>
              </Box>
            </Card>
            <Box
              sx={{
                display: 'flex',
                justifyContent: { sx: 'flex', md: 'flex-end' },
                gap: '10px',
                marginTop: '1rem',
                width: '100%'
              }}
            >
              {existsFilters(filters) && (
                <ResetFilters onClick={() => setFilters({})} />
              )}
              {/* <ResetButton onClick={() => setFilters({})} /> */}
              <Button
                sx={{ width: { xs: '100%', md: 150 } }}
                form="comissions-form"
                type="submit"
              >
                Emitir
              </Button>
            </Box>
          </Grid>
        </Grid>
      </>
    </div>
  )
}

export const ComissionsReportForm = () => {
  const { setFilters } = useComissionsReportContext()

  const handleSubmit = async (data: FormValues) => {
    const normalizedData = {
      customerId: data?.customerId?.companyId,
      dateRange:
        data?.date.length === 2 && !data.date.some((e: any) => e === null)
          ? {
              startDate: data.date[0] && formatDate(new Date(data.date[0])),
              endDate: data.date[1] && formatDate(new Date(data.date[1]))
            }
          : undefined
    }

    setFilters(normalizedData)

    const urlPDF = await commissionsReport({
      data: {
        startDate: normalizedData.dateRange?.startDate,
        endDate: normalizedData.dateRange?.endDate
      }
    })

    window.open(
      `${process.env.REACT_APP_API_URL + '/providers/media/' + urlPDF}`,
      '_blank'
    )
  }

  return (
    <Form<FormValues>
      id="comissions-form"
      onSubmit={handleSubmit}
      schema={comissionsSchema}
      options={{ defaultValues }}
    >
      <ComissionsReportProvided />
    </Form>
  )
}
